import { FC, useEffect, useState } from 'react';
import styles from './ThumbsIcon.module.css';

export enum ThumbsIconVariant {
  PRIMARY = 'primary',
}

enum IconStates {
  DEFAULT = 'default',
  PRESSED = 'pressed',
  SELECTED = 'selected',
}

const stylesConfiguration = {
  [ThumbsIconVariant.PRIMARY]: {
    default: styles.thumbsicon__default,
    pressed: styles.thumbsicon__pressed,
    selected: styles.thumbsicon__selected,
  },
};

interface ThumbsIconProps {
  isSelected: boolean;
  variant?: ThumbsIconVariant;
  isThumbsUp?: boolean;
}

const ThumbsIcon: FC<ThumbsIconProps> = ({
  isSelected,
  variant = ThumbsIconVariant.PRIMARY,
  isThumbsUp = true,
}) => {
  const [iconState, setIconState] = useState(IconStates.DEFAULT);

  const mappedVariant = stylesConfiguration[variant];
  const mappedClassName = () => {
    const outputClass = [];
    if (!isThumbsUp) {
      outputClass.push(styles.thumbsicon__dislike);
    }
    if (iconState === IconStates.DEFAULT) {
      outputClass.push(mappedVariant.default);
    }

    if (iconState === IconStates.PRESSED) {
      outputClass.push(mappedVariant.pressed);
    }

    if (iconState === IconStates.SELECTED) {
      outputClass.push(mappedVariant.selected);
    }

    return outputClass.join(' ');
  };
  const handleMouseLeave = () => {
    if (!isSelected) {
      setIconState(IconStates.DEFAULT);
    }
  };
  const handleBlur = () => {
    if (!isSelected) {
      setIconState(IconStates.DEFAULT);
    }
  };
  const handleMouseDown = () => {
    if (!isSelected) {
      setIconState(IconStates.PRESSED);
    }
  };

  useEffect(() => {
    if (isSelected) {
      setIconState(IconStates.SELECTED);
    } else {
      setIconState(IconStates.DEFAULT);
    }
  }, [isSelected]);
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onBlur={handleBlur}
      className={mappedClassName()}
    >
      <path d='M3.26562 20.5V11.1176H8.76562L10.7068 7.75294V4C12.6739 4 14.2656 5.59176 14.2656 7.55882V10.4706H20.7362V15.6471L17.9344 20.5H3.26562Z' />
      <path
        d='M8.88281 20.5002V9.99805'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  );
};

ThumbsIcon.displayName = 'ThumbsIcon';
export default ThumbsIcon;
